/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Irrigation_Schedule_Remove_TimeInputs */

const vi_irrigation_schedule_remove_time = /** @type {(inputs: Irrigation_Schedule_Remove_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xoá giờ này`)
};

/**

* @param {Irrigation_Schedule_Remove_TimeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const irrigation_schedule_remove_time = /** @type {((inputs?: Irrigation_Schedule_Remove_TimeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Irrigation_Schedule_Remove_TimeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_irrigation_schedule_remove_time(inputs)
});